import React, {useEffect} from 'react';
import {BrowserRouter, Route, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {compose} from "redux";
import {setAuthStatus, setUserId, setUserName} from './store/auth-reducer'
import {appInit} from './store/app-reducer'
import api from './dataAccessLayer/firebase'


//импорт стилей
import './App.css';

//импорт компонентов
import HeaderContainer from "./components/layout/header/HeaderContainer"
import AdvContainer from './components/layout/adv/AdvContainer'
import LoginContainer from "./components/layout/login/LoginContainer";
import Preloader from "./components/layout/preloader/preloader";
import RegisterContainer from "./components/layout/register/RegisterContainer"
import AdvViewContainer from "./components/layout/advView/AdvViewContainer";
import AdvModalCreate from "./components/layout/adv/AdvModalCreate";
import MyContainer from "./components/layout/my/MyContainer";
import MyPosts from "./components/layout/dialogs/MyPosts";
import Favorites from "./components/layout/favorites/favorites";





const App = props => {
    const {
        appInitialized,
        appInit,
        setUserId,
        setAuthStatus,
        setUserName
    } = props;

    useEffect(() => {
        appInit();
        api.isAutorized().then(user => {
            if (user) {
                setAuthStatus(true)
                setUserId(api.getCurrentUserId())
                setUserName(api.getCurrentUsername())
            }
        })
    })



    return (!appInitialized)
        ? <Preloader/>
        : <BrowserRouter basename ={process.env.PUBLIC_URL}>
            <HeaderContainer/>
            <div className='app-wrapper'>
                <Route exact path='/login' component={LoginContainer}/>
                <Route exact path='/register' component={RegisterContainer}/>
                <Route exact path='/my' component={MyContainer}/>
                <Route exact path='/razmestit-obyavlenie/' component={AdvModalCreate}/>
                <Route exact path='/' component={AdvContainer}/>
                <Route exact path='/adv' component={AdvContainer}/>
                <Route exact path='/adv/:id' component={AdvViewContainer}/>
                <Route exact path='/dialogs' component={MyPosts}/>
                <Route exact path='/favorites' component={Favorites}/>
            </div>
        </BrowserRouter>
}


const mapStateToProps = (state) => ({
    appInitialized: state.app.appInitialized
});

export default compose(withRouter, connect(mapStateToProps, {setUserId, setAuthStatus, setUserName, appInit}))(App);
